import { Survey } from '@goldcast/api/backend';

export function processSurveyData(survey: Survey) {
  const processedQuestions = survey.questions.map(question => {
    const processedOptions = question.options?.map(option => {
      return {
        text: option.text
      };
    });

    return {
      question_type: question.question_type,
      required: question.required,
      text: question.text,
      options: processedOptions
    };
  });

  return {
    questions: processedQuestions,
    title: survey.title,
    description: survey.description,
    id: survey.id,
    duplicated_from: survey.duplicated_from,
    broadcasts: survey.broadcasts,
    submit_message: survey.submit_message,
    show_in_on_demand: survey.show_in_on_demand
  };
}
